import React from "react";
import SpotifyLogoImage from "./Spotify_Logo_RGB_White.png";

function SpotifyLogo() {
  return (
    <div>
      <p>
        Powered by...
        <img
          src={SpotifyLogoImage}
          alt="Spotify Logo"
          style={{
            width: "10%",
            height: "10%",
            minWidth: "60px",
            minHeight: "50px",
            maxWidth: "60px",
            maxHeight: "50px",
          }}
        />
      </p>
    </div>
  );
}

export default SpotifyLogo;
